import React, {useContext, useState, useEffect, useMemo} from "react";
import {PageTitle} from "../PageTitle/PageTitle";
import {SignDocsListWithFilters} from "../LearningManagement/SignDocsListWithFilters/SignDocsListWithFilters";
import {I18nReactContext} from "../../contexts/I18nContext";
import {CompanyReactContext} from "../../contexts/CompanyContext";
import {getUserTaskTypes} from "../../Utils/TabFiltering/TabFilteringUtils";
import {SignDocCategories, FeatureFlags} from "../../Utils/Constants";
import {isEmpty} from "lodash";
import {getAllSignDocTypes} from "../SignDoc/SignDocLib";

import "./KnowledgeCenter.scss";

export const KnowledgeCenter = () => {
    const {i18n} = useContext(I18nReactContext);
    const companyContext = useContext(CompanyReactContext);
    const [userKnowledgeCenterTypes, setUserKnowledgeCenterTypes] = useState([]);
    const [isLoadingTypes, setIsLoadingTypes] = useState(true);

    // Load user knowledge center types when component mounts
    useEffect(() => {
        const loadUserTypes = async () => {
            if (isEmpty(companyContext.featureFlags)) {
                return;
            }
            try {
                setIsLoadingTypes(true);
                const kcTypes = await getUserTaskTypes({
                    categories: [SignDocCategories.KNOWLEDGE_CENTER],
                    showForceCompletion: false,
                    showNonForceCompletion: true
                });
                setUserKnowledgeCenterTypes(kcTypes);
            } catch (error) {
                console.error('Error loading knowledge center types:', error);
                setUserKnowledgeCenterTypes([]);
            } finally {
                setIsLoadingTypes(false);
            }
        };

        loadUserTypes();
    }, [companyContext.featureFlags]);

    // Calculate available types for filtering
    const availableKnowledgeCenterTypes = useMemo(() => {
        return [...new Set(userKnowledgeCenterTypes)];
    }, [userKnowledgeCenterTypes]);

    // Determine translation key based on operation mode FF
    const isOperationMode = companyContext.featureFlags?.[FeatureFlags.OPERATION_MODE];
    const translationKey = isOperationMode ? 'operation' : 'knowledgeCenter';

    return <div className="KnowledgeCenter MenuPage">
        <PageTitle title={i18n.translate(`${translationKey}.title`)}
                   subTitle={i18n.translate(`${translationKey}.subTitle`)}/>
        <div className="menuInnerPage">
            {!isLoadingTypes && (
                <SignDocsListWithFilters
                    types={getAllSignDocTypes()}
                    showForceCompletion={false}
                    showNonForceCompletion={true}
                    categories={[SignDocCategories.KNOWLEDGE_CENTER]}
                    filterableTypes={availableKnowledgeCenterTypes}
                    showFilters={{search: true, type: true}}
                    showOnlyUncompletedTasks={true}
                    isUserView={true}
                />
            )}
        </div>
    </div>
}